import type { ReactNode } from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

/** Shared outer shell for Mainstage carousel slides (Log / Recap / Insights). */
export const MAINSTAGE_SLIDE_CARD_CLASS =
  'bg-cream border-deep-100 rounded-3xl p-4 shadow-sm relative overflow-hidden min-h-[480px] h-[480px] flex flex-col';

export const MAINSTAGE_SLIDE_TITLE_CLASS = 'text-lg font-bold text-deep-800 mb-2 shrink-0';

type MainstageSlideCardProps = {
  title: string;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
};

export default function MainstageSlideCard({
  title,
  children,
  className,
  'data-testid': dataTestId = 'mainstage-slide-card',
}: MainstageSlideCardProps) {
  return (
    <Card className={cn(MAINSTAGE_SLIDE_CARD_CLASS, className)} data-testid={dataTestId}>
      <h2 className={MAINSTAGE_SLIDE_TITLE_CLASS}>{title}</h2>
      {children}
    </Card>
  );
}
